// @ts-nocheck
import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager';

import type { GetWhiteboardParamsResult } from './whiteboard-params';

export const getWhiteboardSpot = (
	params: Pick<GetWhiteboardParamsResult, 'canvas-frontend'>,
	name: 'canvas-server' | 'canvas-relay',
) => {
	const spot = params[name];

	// Don't try to read/write local storage in SSR
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		return spot;
	}

	if (spot) {
		try {
			// eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
			localStorage.setItem(name, spot);
		} catch (err) {}

		return spot;
	}

	const savedItem = localStorage.getItem(name);

	if (!savedItem) {
		return;
	}

	const maybeSpot = parseInt(savedItem);

	if (Number.isNaN(maybeSpot)) {
		return;
	}

	return maybeSpot;
};
